<script>
import CountTo from "vue-count-to";

export default {
  functional: true,
  props: {
    options: {
      type: Array,
      require: true
    }
  },
  render(h, { props }) {
    const { options } = props;

    const items = options.map(({ label, icon, startVal, endVal }, index) => (
      <div class="BatteryStatusList__item" key={index}>
        <div class="BatteryStatusList__left">
          <img class="BatteryStatusList__img" src={icon} />
          {label}
        </div>
        <div class="BatteryStatusList__right">
          <div class="BatteryStatusList__value">
            <CountTo startVal={startVal} endVal={endVal} />
          </div>
        </div>
      </div>
    ));

    return <div class="BatteryStatusList">{items}</div>;
  }
};

/**
 * <div class="BatteryStatusList__item" key={index}>
        <div class="BatteryStatusList__left">
          <div class="BatteryStatusList__label">{label}</div>
          <div class="BatteryStatusList__value">
            <CountTo startVal={startVal} endVal={endVal} />
          </div>
        </div>
        <div class="BatteryStatusList__right">
          <img class="BatteryStatusList__img" src={icon} />
        </div>
      </div>

      const items = options.map(({ label, icon, startVal, endVal }, index) => (
      <div class="BatteryStatusList__item" key={index}>
        <div class="BatteryStatusList__left">

        </div>
        <div class="BatteryStatusList__right">

        </div>
      </div>
 */
</script>

<style lang="scss" scoped>
.BatteryStatusList {
  display: flex;
  flex-wrap: wrap;
  width: 630px;
  &__item {
    width: 292px;
    margin-right: 16px;
    margin-top: 16px;
    height:68px;
    background:rgba(26,30,37,1);
    border:1px solid rgba(32,63,63,1);
    display: flex;
    align-items: center;
  }
  &__left {
    display: flex;
    color:#fff;
    align-items: center;
    margin-left: 27px;
  }
  &__img {
    vertical-align: middle;
    width: 31px;
    height: 28px;
  }
  &__right {
    margin-left:40px;
  }
  &__value {
    font-size:30px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(23,239,211,1);
  }
}
</style>

